// @flow

export const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes


export const PLACEHOLDER_DEFAULT = 'Ask Aura anything…';

export const MAX_PROMPT_CHARS = 1000;
